// App wide URLs

import { getCookie } from "../utils/common";

const currentTenant = getCookie("current_tenant");

export const URL = {
  home: `/${currentTenant}`,
  agent: "agent",
  agentToDos: "todos",
  agentConversations: "conversations",
  manager: "",
  conversation: "conversation",
  integrations: "integrations",
  logout: "/logout",
  dashboard: "dashboard",
  search: `search`,
  signIn: "/sign-in",
  signUp: "/sign-up",
};

// Search sunscription periodic notification
export const notificationPeriodicType = [
  {
    type: "daily",
    title: "Daily",
    isDefault: true,
  },
  {
    type: "weekly",
    title: "Weekly",
    isDefault: false,
  },
  {
    type: "immediate",
    title: "Immediately when a new conversation matches this filter",
    isDefault: false,
  },
];

// Random array of colors
export const randomColor = [
  "#ffa566",
  "#8DA2DD",
  "#F6B3C7",
  "#DD403B",
  "#5BD9B6",
  "#D86622",
  "#DFED39",
  "#F24E6D",
  "#A5F7E2",
  "#00b68a",
];

// cookies
export const cookies = [
  "token",
  "token",
  "refresh_token",
  "first_name",
  "last_name",
  "email",
  "profile_pic",
  "unique_user_id",
  "current_tenant",
  "current_tenant_uuid",
];
